export class FindBusinessResult {
    businessName: string = '';
    streetLine1: string = '';
    streetLine2: string = '';
    city: string = '';
    state: string = '';
    zip: string = '';
    phone: string = '';
}